
import { Component, Vue } from "vue-property-decorator";
import configForm from "../data-config/components/config-form.vue";
import { objAny } from "@/common/common-interface";
import tio from "@/common/tiows";
import { topicSubscribe, updToken } from "@/api/api-basic-websocket";
import msgList from "./components/msg-list.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-config-form": configForm,
    "pi-msg-list": msgList
  }
})
export default class CollectionOperData extends Vue {
  private formInline: objAny = {};
  private gunData: objAny = {};

  private msgList: object[] = [];
  private tiows: objAny = {};
  private pilePkId = "";
  private isOpen = 0; // 0 未初始化  1 连接中  2 连接成功  3 连接失败/关闭
  private timer = 0;

  public getContentData(data: objAny, gunData?: objAny) {
    this.formInline = data;
    // this.formInline.pilePkId = "202007140003";
    // this.formInline.gunPkId = "1291540958642114562";
    if (gunData) {
      this.gunData = gunData;
    }
    if (this.formInline.gunPkId == "") {
      this.$Message.error(i18n.t("dataConfig.gunPkIdPl"));
    } else {
      if (this.formInline.gunPkId && this.formInline.gunPkId != "") {
        this.topicSubscribe();
        const msgList: objAny = this.$refs.msgList;
        msgList.init();
      }
    }
  }
  async topicSubscribe() {
    const ret = await topicSubscribe({
      pilePkId: this.formInline.pilePkId,
      msgCodes: [1010, 1020, 1050]
    });
    if (ret.status == this["$config"].apiStatus) {
      console.log("订阅成功");
    }
  }
  async updToken() {
    const ret = await updToken();
    if (ret.status == this["$config"].apiStatus) {
      console.log("刷新token成功");
    } else {
      console.log("刷新token失败");
    }
  }
  public init() {
    this.isOpen = 1;
    this.pilePkId = this.formInline.pilePkId;
    this.tiows = new tio.ws({
      onopen: this.onopen,
      onmessage: this.onmessage,
      onclose: this.onclose,
      ping: this.ping,
      onerror: this.onerror
    });
    this.tiows.connect(true);
  }

  public onopen() {
    console.log("连接成功");
    this.isOpen = 2;
  }
  public onmessage(event: objAny) {
    const data = event.data;
    const msgBody = eval("(" + data + ")");
    console.log(msgBody);
    if (msgBody && msgBody.data) {
      this.msgList.push(msgBody);
    }
    const msgListDiv: objAny = this.$refs.msgList;
    if (msgBody.type == 5 && msgBody.serialNumber == this.gunData.sn) {
      msgListDiv.getUpgradeData(msgBody);
      this.msgList.push(msgBody);
    }
    const msgList: objAny = this.$refs.msgList;
    msgList.append(msgBody);
  }
  public onclose() {
    this.isOpen = 3;
  }
  public ping() {
    // console.log(ws);
  }
  public onerror(ws: objAny, event: objAny) {
    console.log(ws);
    const data = event.data;
    console.log(data);
    // const msgBody = eval("(" + data + ")");
    // console.log(msgBody);
  }
  mounted() {
    this.init();
  }
  created() {
    this.timer = setInterval(this.updToken, 300000);
  }
  beforeDestroy() {
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  }
}
